import { InboxKind } from '_graphql/__generated__/globalTypes';
import { LocationGenerics } from 'router/location';
import { SupplierInbox_supplierInbox } from '_graphql/queries/__generated__/SupplierInbox';

type InboxSearch = Partial<LocationGenerics['Search']>;

export type InboxDestination = {
  to: string;
  search?: (prev?: InboxSearch) => InboxSearch;
};

const payloadRecord = (payload: unknown): Record<string, unknown> =>
  payload && typeof payload === 'object' && !Array.isArray(payload)
    ? (payload as Record<string, unknown>)
    : {};

export const inboxKindLabel: Record<InboxKind, string> = {
  [InboxKind.ORDER_CREATED]: 'New order',
  [InboxKind.ORDER_STATUS_CHANGED]: 'Order status',
  [InboxKind.STOCK_UPDATED]: 'Stock update',
  [InboxKind.WALLET_PAYOUT_PENDING]: 'Payout pending',
  [InboxKind.FAILED_ORDER_CHARGE]: 'Failed charge',
};

export function inboxDestination(item: SupplierInbox_supplierInbox): InboxDestination {
  const payload = payloadRecord(item.payload);

  switch (item.kind) {
    case InboxKind.ORDER_CREATED:
      return { to: `/orders/${item.subjectId}` };
    case InboxKind.ORDER_STATUS_CHANGED: {
      const orderId =
        typeof payload.orderId === 'string' ? payload.orderId : item.subjectId;
      return { to: `/orders/${orderId}` };
    }
    case InboxKind.STOCK_UPDATED:
      return { to: `/products/${item.subjectId}/view` };
    case InboxKind.WALLET_PAYOUT_PENDING:
      return {
        to: '/wallet',
        search: (prev) => ({
          ...prev,
          activeTab: 'payouts',
        }),
      };
    default:
      return { to: '/inbox' };
  }
}
